$(document).ready(function() {
  let pageUrl = document.location.href;
   if(pageUrl.includes('?page=1')){
    const newUrl = pageUrl.split("?page=1")[0];
    window.location.href = newUrl
    
  }
  if ($('.cmp-product-table').length) {
    function is_touch_enabled() {
      return ( 'ontouchstart' in window ) || 
        ( navigator.maxTouchPoints > 0 ) ||
        ( navigator.msMaxTouchPoints > 0 );
    }

    function touchStatus() {
      if(is_touch_enabled()) {
        $(function() { 
          $('html').removeClass('no-touch').addClass('touch');

          var clone = $('.compare-ext-info').clone().addClass('clone');
          $('.compare-ext-info').remove();
          $('.cmp-product-wrap1').append(clone);
        });
      } else {
        $(function() { 
          $('html').removeClass('touch').addClass('no-touch');

          if($('.compare-ext-info').hasClass('clone')) {
            var clone = $('.compare-ext-info').clone();
            $('.compare-ext-info').remove();
            $('.cmp-product-table').append(clone);
          }
        });
      }
    }

    touchStatus();
    $(window).resize(function(){
      touchStatus();
    });

    $('.cmp-info-detail').each(function(){
      $(this).children('li').each(function(i,e){
        $(this).addClass('cmp-li-'+i);
      });
    });

    function columnHeight(){
      $('.cmp-table-wrapper').each(function(){
        var $this = $(this);
        var length = $this.find('.cmp-product-lbls li').length;

        for (let i = 0; i < length; i++) {
          var maxHeight = 0;
          $this.find('.cmp-li-'+i).each(function(){
            if($(this).find('.cpm-li-wrap').innerHeight() > maxHeight) {
              maxHeight = $(this).find('.cpm-li-wrap').innerHeight();
            }
            $this.find('.cmp-li-'+i).css('height', maxHeight);
          });      
        }
      });
    }

    columnHeight();
    $(window).resize(function(){
      columnHeight();
    });

    $(document).on('click', '.cpm-ext-toggle', function() {
      $('.cmp-product-table').attr('aria-expanded', function(index, attr){
        return attr == 'true' ? null : 'true';
      });
      $(this).toggleClass('active').parents('.compare-ext-block').find('.compare-ext-content').fadeToggle(200);
      setTimeout(function(){
        var scrollLeft = $('.cmp-product-wrap1').scrollLeft();
        $('.cmp-product-wrapper').scrollLeft(scrollLeft);
      },  50);
      stickyImage();
      columnHeight();
    });

    compareArrowScroll();
    $(window).resize(function(){
      compareArrowScroll();
    });

    $('.cmp-product-wrapper').on('scroll', function() {
      var scrollLeft = $(this).scrollLeft();
      compareArrowScroll();

      $('.cmp-product-wrapper').scrollLeft(scrollLeft);
    });

    $(document).on('click', '.cmp-arrow', function() {
      var ele = $(this);
      compareArrowClicked(ele);
    });

    $(document).on('click', '.cmp-chckbox', function() {
      var index = $(this).parents('.cmp-product-item').data('index');

      $(`.cmp-product-item[data-index=${index}]`).toggleClass('selected');

      if($('.cmp-product-item.selected').length > 1) {
        if(!$('.cmp-product-table').hasClass('filtered')) {
          $('.filter-btn').removeClass('disabled');
        }
      } else {
        $('.filter-btn').addClass('disabled');
        if($('.cmp-product-item.selected').length < 1) {
          $('.cmp-product-table').removeClass('filtering filtered');
        }  
      }

      compareArrowScroll();
    });

    $(document).on('click', '.filter-btn', function() {
      if(!$(this).hasClass('disabled')) {
        $(this).addClass('disabled');
        $('.cmp-product-table').addClass('filtering');
        setTimeout(function() {
          $('.cmp-product-table').addClass('filtered');
        }, 300);
      }

      setTimeout(function(){
        compareArrowScroll();
      }, 300);
    });

    $(document).on('click', '.reset-btn', function() {
      $('.filter-btn').addClass('disabled');
      $('.cmp-product-item').removeClass('selected');
      $('.cmp-product-table').removeClass('filtering filtered');

      compareArrowScroll();
    });


    function compareArrowScroll() {
      var parentOffset = $('.cmp-product-table').offset().left + $('.cmp-product-lbls').innerWidth();
      var elementOffset = $('.cmp-product-row').offset().left;
      var parentOffset2 = $('.cmp-product-table').offset().left + $('.cmp-product-table').innerWidth();
      var elementOffset2 = $('.cmp-product-row').offset().left + $('.cmp-product-row').innerWidth();

      var parentWidth = $('.cmp-product-table').innerWidth();
      var stickyWidth = $('.cmp-product-table .cmp-product-row').innerWidth() + $('.cmp-product-lbls').innerWidth();

      $('.compare-ext-info').css('min-width', stickyWidth)
      $('.compare-ext-title').css('width', parentWidth);

      if(parentOffset > elementOffset) {
        $('.cmp-product-table').addClass('scrolling');
        $('.cmp-prev').removeClass('disabled');
      } else {
        $('.cmp-product-table').removeClass('scrolling');
        $('.cmp-prev').addClass('disabled');
      }

      if(parentOffset2 < elementOffset2) {
        $('.cmp-next').removeClass('disabled');
      } else {
        $('.cmp-next').addClass('disabled');
      }

      if($(window).width() > 1000) {
        $('.cmp-product-item').each(function(){
          var offset = $('.cmp-product-row').offset().left - ($('.cmp-product-wrapper').offset().left + $('.cmp-product-lbls').innerWidth());
          $(this).find('.cmp-image').css('transform', 'translateX('+offset+'px)');
        });
      } else {
        $('.cmp-product-item .cmp-image').css('transform', 'translateX(0)');
      }
    }

    function compareArrowClicked(ele) {
      var scrollOffset = $('.cmp-product-wrapper').scrollLeft();
      var clickScroll = $('.cmp-product-item').innerWidth();

      if(ele.is('.cmp-next')) {
        var scroll = scrollOffset + clickScroll;
        $('.cmp-product-wrapper').animate({ scrollLeft: scroll }, 10);
      } else {
        var scroll = scrollOffset - clickScroll;
        $('.cmp-product-wrapper').animate({ scrollLeft: scroll }, 10);
      }
    }

    function stickyImage() {
      var windowScroll = $(window).scrollTop();
      var stickyOffset = $('.cmp-product-table').offset().top + $('.cmp-image img').innerHeight();
      var windowScroll2 = windowScroll + $('.cmp-product-item .cmp-image').innerHeight();

      if($('.cmp-product-table[aria-expanded="true"]').length) {
        var parentOffset2 = $('.cmp-product-wrap2').offset().top + $('.cmp-product-wrap2').innerHeight();
        var stickyOffset2 = $('.cmp-product-wrap2 .cmp-product-row').offset().top + $('.cmp-product-wrap2 .cmp-product-row').innerHeight();
        var marginOffset = parentOffset2 - stickyOffset2;

        $('.cmp-product-lbls .cmp-image, .cmp-product-item .cmp-image').css('margin-bottom', marginOffset+1);
      } else {
        var stickyOffset2 = $('.cmp-product-wrap1 .cmp-product-row').offset().top + $('.cmp-product-wrap1 .cmp-product-row').innerHeight();
        $('.cmp-product-lbls .cmp-image, .cmp-product-item .cmp-image').css('margin-bottom', 0);
      }

      if(windowScroll > stickyOffset) {
        $('.cmp-product-table').addClass('isticky');
      } else {
        $('.cmp-product-table').removeClass('isticky');
      }

      if(windowScroll2 > stickyOffset2) {
        $('.cmp-product-table').addClass('stick-bottom');
      } else {
        $('.cmp-product-table').removeClass('stick-bottom');
      }
    }

    stickyImage();
    $(window).on('scroll', function(){
      stickyImage();
    });
  }

  $(document).on('click', '.CartDrawer_assembly-popup-box', function (e) {
    e.stopPropagation();
  });

  $(document).on('click', '.CartDrawer_assembly-popup, .CartDrawer_assembly-popup-close, .CartDrawer_assembly--cancel', function (e) {
    $('body').removeClass('assembly-popup-opened');

    const assemblyQty = document.querySelector('.cart-assembly-item .js-qty__num');
    if (assemblyQty) assemblyQty.value = assemblyQty.dataset.qty;
  });

  $(document).on('click', '.CartDrawer_assembly--approve', function (e) {
    theme.settings.removeAssembly = true;

    $('body').removeClass('assembly-popup-opened');
    $('.cart-assembly-item .js-qty__adjust--minus').click();
  });
});


$(document).on("click", ".product-recommendations-add-to-cart-area .add-to-cart1", function (e) {
  e.preventDefault();
  console.log("submit");
  var product_id = $(this).parents('.product-recommendations-add-to-cart-area').find('[name="id"]').val();
  console.log("submit=", product_id);
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      quantity: 1,
      id: product_id
    },
    dataType: 'json', 
    success: function (data) { 
     console.log("data=", data);
    } 
 });
})
  // if($('html').hasClass('loading')){
  //   $('html').removeClass('loading');
  // }
  // document.classList.contains('loading') ? document.classList.remove('loading') : null;
function removeLoadedClass() {
	var root = document.documentElement;
	if (!root.classList.contains("loading-state")) return;
	var unlocked = false;
	function unlock() {
		if (unlocked) return;
		unlocked = true;
		setTimeout(function () {
			root.classList.remove("loading-state");
		}, 0);
	}
	window.addEventListener("load", unlock);
	document.addEventListener("DOMContentLoaded", function () {
		setTimeout(unlock, 3000);
	});
}
removeLoadedClass()